<template>
  <div class="box text-gray-50">
    <div class="box-heading d-flex align-items-center justify-content-between">
      <div class="text-13">快速文档入口</div>
    </div>
    <ul>
      <li class="py-1">
        <docs-icon class="mr-1"/>
        <a
          class="text-gray-50"
          href="https://book.go-admin.cn"
          target="_blank"
        >GoAdmin开发文档</a>
      </li>
    </ul>
  </div>
</template>

<script>
import DocsIcon from '$icons/FileDocumentBoxOutline'

export default {
  name: 'quick-docs',
  components: { DocsIcon }
}
</script>

<style scoped>
</style>
